import { Button, Popconfirm, Space } from "antd";
import { useNavigate } from "react-router-dom";
import TableComponent from "../../components/TableComponent";
import { deleteCoupon, getCoupons } from "../../store/slices/couponSlice";
import { DeleteFilled, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { useState } from "react";
import Can from "../../permission/Can";

const CouponList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("success");
    const [reload, setReload] = useState(false);
    const [open, setOpen] = useState(null);
    const [confirmLoading, setConfirmLoading] = useState(false);

    const showPopconfirm = (id) => {
        setOpen(id);
    };

    const handleDeleteCoupon = async (id) => {
        try {
            setConfirmLoading(true);

            const resultAction = await dispatch(deleteCoupon(id));

            if (deleteCoupon.fulfilled.match(resultAction)) {
                setAlertMessage(resultAction?.payload?.message || "Deleted");
                setAlertType("success");
                setReload(!reload);
                setOpen(null);
            }
        } catch (error) {
            setAlertMessage("Error deleting coupon");
            setAlertType("error");
        } finally {
            setConfirmLoading(false);
            setTimeout(() => setAlertMessage(""), 4000);
        }
    };

    const handleCancel = () => {
        setOpen(null);
    };

    const columns = [
        {
            title: "Code",
            dataIndex: "code",
            key: "code",
        },
        {
            title: "Discount (%)",
            dataIndex: "discount_percent",
            key: "discount_percent",
            render: (value) => `${value}%`
        },
        {
            title: "Status",
            dataIndex: "is_active",
            key: "is_active",
            render: (value) => (
                <span style={{ color: value ? "green" : "red" }}>
                    {value ? "Active" : "Inactive"}
                </span>
            )
        },
        {
            title: "Created At",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (_, data) => {
                const date = new Date(data?.createdAt);
                return date.toDateString();
            }
        },
        {
            title: "Actions",
            key: "actions",
            render: (_, data) => (
                <Space>
                    <Can permission="edit_coupon">
                        <Button
                            onClick={() => navigate('/coupon/edit/' + data?._id)}
                            icon={<EditOutlined />}
                            size="small"
                        >
                            Edit
                        </Button>
                    </Can>
                    
                    <Can permission="delete_coupon">
                        <Popconfirm
                            title="Delete confirmation"
                            description="Do you want to delete this coupon?"
                            open={open === data?._id}
                            icon={<DeleteFilled />}
                            onConfirm={() => handleDeleteCoupon(data?._id)}
                            okButtonProps={{ loading: confirmLoading }}
                            onCancel={handleCancel}
                        >
                            <Button
                                icon={<DeleteOutlined />}
                                onClick={() => showPopconfirm(data?._id)}
                                size="small"
                                danger
                            >
                                Delete
                            </Button>
                        </Popconfirm>
                    </Can>
                </Space>
            ),
        },
    ];

    return (
        <div>
            <div style={{
                marginBottom: 16,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}>
                <h1>Coupons</h1>
                {/* {hasPermission(user, PERMISSIONS.COUPON_CREATE) && (
                    <Button type="primary" onClick={() => navigate('/coupon/add')}>
                        Add Coupon
                    </Button>
                )} */}
                <Can permission="create_coupon">
                    <Button type="primary" onClick={() => navigate('/coupon/add')}>
                        Add Coupon
                    </Button>
                </Can>
            </div>

            <TableComponent
                listData={getCoupons}
                columns={columns}
                reload={reload}
                placeholder="Search coupons..."
            />
        </div>
    );
};

export default CouponList;